module.exports = __webpack_public_path__ + "img/volume_enabled.5c03fa07.svg";